import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { LoggedInHeaderComponent } from '../../../components/logged-in-header/logged-in-header.component';
import { AuthenticationService } from '../../../modules/services/authentication.service';

@Component({
  selector: 'app-user-dashboard-shell',
  standalone: true,
  imports: [CommonModule, RouterModule, LoggedInHeaderComponent],
  templateUrl: './user-dashboard-shell.component.html',
  styleUrl: './user-dashboard-shell.component.scss',
})
export class UserDashboardShellComponent {
  authenticationService: AuthenticationService = inject(AuthenticationService);
  constructor(private readonly router: Router) {}

  get hideTopTabs(): boolean {
    return /^\/user\/vendors\/((new)|\w+)/.test(this.router.url);
  }
}
